
export const homeObjOne = {
    id:'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Développeur Full-Stack',
    headline: 'Accompagnement illimité dans le temps',
    description: 'Parce qu\'une idée de projet n\'est jamais figé dans le temps, soyez accompagné aussi longtemps que vous en avez besoin.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/SVG/Backgrounds/bg1.svg'),
    alt: 'a car',
    dark: true,
    primary: true,
    darkText: false
}